import type { OrderPlaybackConfig } from '@order/features/ordering';

export const getOrderPlaybackConfig = (
  config?: Record<string, number>,
): OrderPlaybackConfig => {
  const playbackHeaderFadeDuration = config?.playbackHeaderFadeDuration ?? 1000;
  const playbackBodyFadeDuration = config?.playbackBodyFadeDuration ?? 1000;
  const playbackTimerDuration = config?.playbackTimerDuration ?? 3000;
  const orderSubmissionDelay =
    playbackHeaderFadeDuration +
    playbackBodyFadeDuration +
    playbackTimerDuration;

  return {
    orderSubmissionDelay,
    playbackHeaderFadeDuration,
    playbackBodyFadeDuration,
    playbackTimerDuration,
  };
};
